import flatten from 'lodash.flatten';

import getAvailableCategoryMenuItems from './getAvailableCategoryMenuItems';

const getCategoryItems = (categories = []) =>
  flatten(getAvailableCategoryMenuItems(categories).map(({ categoryItems }) => categoryItems));

export default getCategoryItems;
